var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25822_36335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.957 5.34375C14.0616 5.34375 14.957 4.44832 14.957 3.34375C14.957 2.23918 14.0616 1.34375 12.957 1.34375C11.8525 1.34375 10.957 2.23918 10.957 3.34375C10.957 4.44832 11.8525 5.34375 12.957 5.34375Z",
    stroke: "#008C82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95703 10.0103C6.0616 10.0103 6.95703 9.11482 6.95703 8.01025C6.95703 6.90568 6.0616 6.01025 4.95703 6.01025C3.85246 6.01025 2.95703 6.90568 2.95703 8.01025C2.95703 9.11482 3.85246 10.0103 4.95703 10.0103Z",
    stroke: "#008C82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.957 14.6768C14.0616 14.6768 14.957 13.7813 14.957 12.6768C14.957 11.5722 14.0616 10.6768 12.957 10.6768C11.8525 10.6768 10.957 11.5722 10.957 12.6768C10.957 13.7813 11.8525 14.6768 12.957 14.6768Z",
    stroke: "#008C82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68359 9.01709L11.2369 11.6704",
    stroke: "#008C82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2303 4.3501L6.68359 7.00343",
    stroke: "#008C82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25822_36335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.957031 0.0102539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreen);
export default __webpack_public_path__ + "static/media/shareGreen.d7f6b90ffff6bd1023063b2234b82529.svg";
export { ForwardRef as ReactComponent };